export default "__VITE_ASSET__Cr0RRrJ4__"